import { Link } from 'react-router-dom';
import { createPageUrl } from '@/utils';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/components/utils/useLanguage';

export default function ActivityNotFound() {
  const { t } = useLanguage();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">
        {t('Ausflug nicht gefunden', 'Activity not found')}
      </h1>
      <Link to={createPageUrl('Ausflugsideen')}>
        <Button>{t('Alle Ausflüge anzeigen', 'View all activities')}</Button>
      </Link>
    </div>
  );
}